import { DownloadButton } from "@ugitgud/legos/ui/form/button/DownloadButton";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscDownloadFill } from "@ugitgud/legos/ui/icon/SVG/MiscDownloadFill";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";

export const HIGHLIGHTS_CTA_ID = "app-highlights-2";

interface HighlightsBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function HighlightsBanner(props: HighlightsBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;

  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        className,
        `
        h-[48px] relative px-[12px] w-full bg-no-repeat bg-right bg-accent-gray-75
        bg-[url('https://static.bigbrain.gg/assets/ugg/cta/highlights-banner.png')]
    `,
      )}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-400/0 z-0" />
      <div
        className={classNames("flex items-center relative justify-center max-xs:justify-start gap-[18px] h-full", {
          "max-xs:pr-[36px]": onClose,
        })}
      >
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)]">
          <div className="font-bold text-[18px] text-white">
            <span className="!font-barlow-condensed capitalize">NEVER MISS YOUR HIGHLIGHTS</span>
          </div>
          <div className="font-inter font-medium text-[12px] text-white">Auto-save your best plays with the U.GG app</div>
        </div>
        <DownloadButton
          className="h-[30px] px-3 py-2 space-x-1.5 shadow-[0px_1px_0px_0px_rgba(0,_0,_0,_0.40)] hover:shadow-none font-inter"
          href={href}
          onClick={onUrlClick}
        >
          <Icon icon={<SvgMiscDownloadFill />} size="custom" className="w-4.5 h-4" />
          <div>Download</div>
        </DownloadButton>
      </div>
      {onClose && (
        <div
          className="absolute top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-50 z-[1]"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
